import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "mg-slide" };
const _hoisted_2 = {
    key: 0,
    class: "slide-image-container"
};
const _hoisted_3 = ["src", "loop"];
const _hoisted_4 = ["src"];
import { ref, computed, watch, onMounted, nextTick } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MGSheetSlide',
    props: {
        imageUri: { default: null },
        imageHeight: { default: '220' },
        videoLoop: { type: Boolean, default: false },
        variant: { default: 'sheet' }
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "295319d4": (_ctx.imageHeight + 'px')
        }));
        const props = __props;
        const videoElement = ref(null);
        const isVideo = computed(() => {
            if (!props.imageUri)
                return false;
            const videoExtensions = ['.mp4', '.webm', '.mov', '.avi'];
            return videoExtensions.some(ext => props.imageUri.toLowerCase().endsWith(ext));
        });
        function playVideo() {
            const video = videoElement.value;
            if (video) {
                const playPromise = video.play();
                if (playPromise !== undefined) {
                    playPromise.catch(error => {
                        if (error.name === 'AbortError') {
                            console.debug('Video autoplay was interrupted by the browser for power saving');
                        }
                        else if (error.name === 'NotAllowedError') {
                            console.debug('Video autoplay was blocked by browser autoplay policy');
                        }
                    });
                }
            }
        }
        watch(() => props.imageUri, () => {
            nextTick(() => {
                playVideo();
            });
        });
        onMounted(() => {
            nextTick(() => {
                playVideo();
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.imageUri)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (isVideo.value)
                            ? (_openBlock(), _createElementBlock("video", {
                                key: 0,
                                ref_key: "videoElement",
                                ref: videoElement,
                                src: _ctx.imageUri,
                                muted: "",
                                loop: _ctx.videoLoop,
                                playsinline: "",
                                poster: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
                                class: _normalizeClass(["slide-image", `${_ctx.variant}-variant`])
                            }, null, 10, _hoisted_3))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: _ctx.imageUri,
                                alt: "",
                                class: _normalizeClass(["slide-image", `${_ctx.variant}-variant`])
                            }, null, 10, _hoisted_4))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
